import { useParams, useLocation } from 'react-router-dom';
import { ExternalLink } from 'lucide-react';
import AppLayout from '../components/AppLayout';
import TrendlyneWidgets from '../components/TrendlyneWidgets';

export default function StockAnalysis() {
  const { symbol } = useParams();
  const location = useLocation();
  const backTo = location.state?.from || '/live';
  const backLabel = location.state?.fromLabel || '← Trading';

  if (!symbol) {
    return <AppLayout><p className="p-8 text-sm text-muted-foreground">No symbol specified.</p></AppLayout>;
  }

  return (
    <AppLayout backTo={backTo} backLabel={backLabel} title={symbol}>
      <div className="px-2 md:px-6 py-4 border-b border-border bg-surface-base flex items-center justify-between gap-4">
        <h1 className="text-lg font-bold text-foreground">{symbol} — Stock Market Analysis</h1>
        <a
          href={`https://www.google.com/search?q=${encodeURIComponent(symbol)}+site:trendlyne.com&btnI=1`}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-1.5 text-xs px-3 py-1.5 rounded-md border border-border hover:bg-muted transition-colors text-foreground whitespace-nowrap"
        >
          <ExternalLink size={13} />
          View full details on Trendlyne
        </a>
      </div>
      <div className="p-2 md:p-6 max-w-6xl mx-auto">
        <TrendlyneWidgets symbol={symbol} />
      </div>
    </AppLayout>
  );
}
